(function () {
  'use strict';

  const config = window.__storeLocatorConfig;
  if (!config) return;

  let map;
  let markers = [];
  let infoWindow;
  let geocoder;
  let autocomplete;
  let initialCenter = null;
  let initialZoom = null;
  let allStores = config.stores || [];
  let filteredStores = [...allStores];

  /* ── Initialise Google Maps ─────────────────────────────────────────────── */
  function initMap() {
    const mapEl = document.getElementById('store-locator-map');
    if (!mapEl) return;

    map = new google.maps.Map(mapEl, {
      center: { lat: parseFloat(config.defaultLat), lng: parseFloat(config.defaultLng) },
      zoom: config.defaultZoom || 5,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      styles: [
        { elementType: 'geometry', stylers: [{ saturation: -100 }] },
        { elementType: 'labels.text.fill', stylers: [{ saturation: -100 }, { lightness: 10 }] },
        { elementType: 'labels.text.stroke', stylers: [{ saturation: -100 }, { lightness: 100 }] },
        { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#e9e9e9' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 50 }] },
        { featureType: 'road.highway', elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 40 }] },
        { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 20 }] },
        { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#333333' }] },
        { featureType: 'landscape', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
      ],
    });

    infoWindow = new google.maps.InfoWindow();
    geocoder = new google.maps.Geocoder();

    // Geocode stores that have no coordinates, then place markers
    geocodeMissingCoordinates().then(function () {
      addMarkers(allStores);
      fitBounds();
    });

    // Setup Places Autocomplete
    setupAutocomplete();
  }

  /* ── Markers ────────────────────────────────────────────────────────────── */
  function clearMarkers() {
    markers.forEach(function (m) {
      m.setMap(null);
    });
    markers = [];
  }

  /* ── Custom marker icon ─────────────────────────────────────────────────── */
  var markerIcon = null;

  function getMarkerIcon() {
    if (!markerIcon) {
      markerIcon = {
        url:
          'data:image/svg+xml;charset=UTF-8,' +
          encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="44" viewBox="0 0 32 44">' +
              '<path d="M16 0C7.163 0 0 7.163 0 16c0 12 16 28 16 28s16-16 16-28C32 7.163 24.837 0 16 0z" fill="#000000"/>' +
              '<circle cx="16" cy="15" r="6" fill="#ffffff"/>' +
              '</svg>',
          ),
        scaledSize: new google.maps.Size(32, 44),
        anchor: new google.maps.Point(16, 44),
      };
    }
    return markerIcon;
  }

  function addMarkers(stores) {
    stores.forEach(function (store) {
      if (!store.lat || !store.lng) return;
      var marker = new google.maps.Marker({
        position: { lat: parseFloat(store.lat), lng: parseFloat(store.lng) },
        map: map,
        title: store.name,
        icon: getMarkerIcon(),
      });

      marker.addListener('click', function () {
        openInfoWindow(store, marker);
        highlightCard(store.id);
      });

      marker.storeId = store.id;
      markers.push(marker);
    });
  }

  function fitBounds() {
    if (markers.length === 0) return;
    if (markers.length === 1) {
      map.setCenter(markers[0].getPosition());
      map.setZoom(14);
      saveInitialPosition();
      return;
    }
    var bounds = new google.maps.LatLngBounds();
    markers.forEach(function (m) {
      bounds.extend(m.getPosition());
    });
    map.fitBounds(bounds);
    // fitBounds is async — capture the settled position after idle
    google.maps.event.addListenerOnce(map, 'idle', saveInitialPosition);
  }

  function saveInitialPosition() {
    initialCenter = map.getCenter();
    initialZoom = map.getZoom();
  }

  /* ── InfoWindow ─────────────────────────────────────────────────────────── */
  function openInfoWindow(store, marker) {
    var phone = store.phone
      ? '<br><a href="tel:' + encodePhone(store.phone) + '">' + escapeHtml(store.phone) + '</a>'
      : '';
    var website = store.website
      ? '<br><a href="' +
        escapeHtml(store.website) +
        '" target="_blank" rel="noopener noreferrer">' +
        escapeHtml(prettyUrl(store.website)) +
        '</a>'
      : '';

    var content =
      '<div class="store-locator__info-window">' +
      '<strong>' +
      escapeHtml(store.name) +
      '</strong>' +
      '<p>' +
      escapeHtml(store.address || '') +
      (store.city ? '<br>' + escapeHtml(store.city) : '') +
      (store.state ? ', ' + escapeHtml(store.state) : '') +
      ' ' +
      escapeHtml(store.zip || '') +
      (store.country ? '<br>' + escapeHtml(store.country) : '') +
      phone +
      website +
      '</p>' +
      '</div>';

    infoWindow.setContent(content);
    infoWindow.open(map, marker);
  }

  /* ── Highlight card ─────────────────────────────────────────────────────── */
  function highlightCard(storeId) {
    document.querySelectorAll('.store-locator__card').forEach(function (card) {
      card.classList.remove('is-active');
    });
    var card = document.querySelector('[data-store-id="' + storeId + '"]');
    if (card) {
      card.classList.add('is-active');
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  /* ── View on map (click on card) ────────────────────────────────────────── */
  function attachViewMapButtons() {
    document.querySelectorAll('.store-locator__card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        // Don't intercept clicks on links inside the card
        if (e.target.closest('a')) return;

        var storeId = this.getAttribute('data-store-id');

        // Toggle: click active card → deactivate and reset map
        if (this.classList.contains('is-active')) {
          this.classList.remove('is-active');
          if (infoWindow) infoWindow.close();
          if (map && initialCenter) {
            map.setCenter(initialCenter);
            map.setZoom(initialZoom);
          }
          return;
        }

        var lat = parseFloat(this.getAttribute('data-store-lat'));
        var lng = parseFloat(this.getAttribute('data-store-lng'));

        if (lat && lng && map) {
          map.setCenter({ lat: lat, lng: lng });
          map.setZoom(15);

          var marker = markers.find(function (m) {
            return m.storeId === storeId;
          });
          if (marker) {
            var store = allStores.find(function (s) {
              return s.id === storeId;
            });
            if (store) openInfoWindow(store, marker);
          }
        }
        if (storeId) highlightCard(storeId);

        // Scroll to map on mobile
        var mapWrapper = document.querySelector('.store-locator__map-wrapper');
        if (mapWrapper && window.innerWidth < 990) {
          mapWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      // Keyboard accessibility
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /* ── Geocode stores without coordinates ─────────────────────────────────── */
  function geocodeMissingCoordinates() {
    var toGeocode = allStores.filter(function (s) {
      var lat = parseFloat(s.lat);
      var lng = parseFloat(s.lng);
      return !lat || !lng || isNaN(lat) || isNaN(lng);
    });
    if (toGeocode.length === 0) return Promise.resolve();

    console.info('[Store Locator] Geocoding ' + toGeocode.length + ' store(s) without coordinates…');

    var promises = toGeocode.map(function (store, index) {
      return new Promise(function (resolve) {
        var addressParts = [store.address, store.city, store.state, store.zip, store.country].filter(Boolean);
        var fullAddress = addressParts.join(', ');
        if (!fullAddress) {
          console.warn('[Store Locator] "' + store.name + '" has no address to geocode.');
          resolve();
          return;
        }

        // Stagger requests to respect rate limits
        setTimeout(function () {
          geocoder.geocode({ address: fullAddress }, function (results, status) {
            if (status === 'OK' && results[0]) {
              store.lat = results[0].geometry.location.lat();
              store.lng = results[0].geometry.location.lng();
              console.info('[Store Locator] ✓ Geocoded "' + store.name + '" → ' + store.lat + ', ' + store.lng);
              // Update the card's data attributes
              var card = document.querySelector('[data-store-id="' + store.id + '"]');
              if (card) {
                card.setAttribute('data-store-lat', store.lat);
                card.setAttribute('data-store-lng', store.lng);
                var viewBtn = card.querySelector('.store-locator__view-map');
                if (viewBtn) {
                  viewBtn.setAttribute('data-lat', store.lat);
                  viewBtn.setAttribute('data-lng', store.lng);
                }
              }
            } else {
              console.error(
                '[Store Locator] ✗ Failed to geocode "' + store.name + '" (' + fullAddress + '): ' + status,
              );
              if (status === 'REQUEST_DENIED') {
                console.error(
                  '[Store Locator] → The Geocoding API is likely not enabled. Enable it at https://console.cloud.google.com/apis/library/geocoding-backend.googleapis.com',
                );
              }
            }
            resolve();
          });
        }, index * 250);
      });
    });

    return Promise.all(promises);
  }

  /* ── Places Autocomplete ────────────────────────────────────────────────── */
  function setupAutocomplete() {
    var input = document.getElementById('store-locator-search');
    if (!input || !google.maps.places) return;

    autocomplete = new google.maps.places.Autocomplete(input, {
      types: ['(regions)'],
      fields: ['geometry', 'formatted_address'],
    });

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place && place.geometry) {
        var loc = place.geometry.location;
        sortStoresByDistance(loc.lat(), loc.lng());
        map.setCenter({ lat: loc.lat(), lng: loc.lng() });
        map.setZoom(10);
      } else {
        applyFilters();
      }
    });
  }

  /* ── Sort stores by distance to a point ─────────────────────────────────── */
  function sortStoresByDistance(lat, lng) {
    var query = (document.getElementById('store-locator-search').value || '').toLowerCase().trim();
    var activeFilters = getActiveFilters();

    filteredStores = allStores.filter(function (store) {
      if (!store.lat || !store.lng) return false;
      if (activeFilters.length > 0) {
        var matchesFilter = activeFilters.some(function (f) {
          return store.badge === f || store.badge === 'both';
        });
        if (!matchesFilter) return false;
      }
      return true;
    });

    filteredStores.sort(function (a, b) {
      var dA = haversine(lat, lng, a.lat, a.lng);
      var dB = haversine(lat, lng, b.lat, b.lng);
      return dA - dB;
    });

    // Re-order DOM cards
    var container = document.getElementById('store-locator-results');
    filteredStores.forEach(function (store) {
      var card = container.querySelector('[data-store-id="' + store.id + '"]');
      if (card) {
        card.style.display = '';
        container.appendChild(card);
      }
    });

    // Hide non-matching
    var visibleIds = filteredStores.map(function (s) {
      return s.id;
    });
    container.querySelectorAll('.store-locator__card').forEach(function (card) {
      if (visibleIds.indexOf(card.getAttribute('data-store-id')) === -1) {
        card.style.display = 'none';
      }
    });

    var countEl = document.getElementById('store-locator-count');
    if (countEl) countEl.textContent = filteredStores.length;

    clearMarkers();
    addMarkers(filteredStores);
    fitBounds();
  }

  /* ── Haversine distance (km) ────────────────────────────────────────────── */
  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLng = ((lng2 - lng1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /* ── Search ─────────────────────────────────────────────────────────────── */
  function setupSearch() {
    var input = document.getElementById('store-locator-search');
    if (!input) return;

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        applyFilters();
      }, 300);
    });

    var searchBtn = document.querySelector('.store-locator__search-btn');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        applyFilters();
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyFilters();
      }
    });
  }

  /* ── Filter checkboxes ──────────────────────────────────────────────────── */
  function setupFilters() {
    document.querySelectorAll('.store-locator__filter-checkbox').forEach(function (cb) {
      cb.addEventListener('change', function () {
        applyFilters();
      });
    });
  }

  /* ── Get active filter values ─────────────────────────────────────────── */
  function getActiveFilters() {
    var filters = [];
    document.querySelectorAll('.store-locator__filter-checkbox:checked').forEach(function (cb) {
      filters.push(cb.value);
    });
    return filters;
  }

  /* ── Apply search + filters ─────────────────────────────────────────────── */
  function applyFilters() {
    var query = (document.getElementById('store-locator-search').value || '').toLowerCase().trim();
    var activeFilters = getActiveFilters();

    filteredStores = allStores.filter(function (store) {
      // Text search
      if (query) {
        var searchString = [store.name, store.address, store.city, store.state, store.zip, store.country]
          .join(' ')
          .toLowerCase();
        if (searchString.indexOf(query) === -1) return false;
      }

      // Badge filter
      if (activeFilters.length > 0) {
        var matchesFilter = activeFilters.some(function (f) {
          return store.badge === f || store.badge === 'both';
        });
        if (!matchesFilter) return false;
      }

      return true;
    });

    renderResults(filteredStores);
    clearMarkers();
    addMarkers(filteredStores);
    fitBounds();
  }

  /* ── Render filtered results ────────────────────────────────────────────── */
  function renderResults(stores) {
    var container = document.getElementById('store-locator-results');
    if (!container) return;

    var storeIds = stores.map(function (s) {
      return s.id;
    });

    container.querySelectorAll('.store-locator__card').forEach(function (card) {
      var id = card.getAttribute('data-store-id');
      card.style.display = storeIds.indexOf(id) !== -1 ? '' : 'none';
      card.classList.remove('is-active');
    });

    // Update count
    var countEl = document.getElementById('store-locator-count');
    if (countEl) countEl.textContent = stores.length;
  }

  /* ── Helpers ────────────────────────────────────────────────────────────── */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function encodePhone(phone) {
    return phone.replace(/[\s()]/g, '');
  }

  function prettyUrl(url) {
    return url
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split('/')[0];
  }

  /* ── Load Google Maps API ───────────────────────────────────────────────── */
  function loadGoogleMaps() {
    if (!config.apiKey) {
      var mapEl = document.getElementById('store-locator-map');
      if (mapEl) {
        mapEl.innerHTML =
          '<div style="display:flex;align-items:center;justify-content:center;height:100%;padding:2rem;text-align:center;color:#666;">' +
          '<p>Google Maps API key is required.<br>Add it in the theme editor under Store Locator settings.</p>' +
          '</div>';
      }
      return;
    }

    if (window.google && window.google.maps) {
      initMap();
      return;
    }

    var script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(config.apiKey) +
      '&libraries=places&callback=__initStoreLocatorMap';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  window.__initStoreLocatorMap = function () {
    initMap();
  };

  /* ── Boot ────────────────────────────────────────────────────────────────── */
  function boot() {
    setupSearch();
    setupFilters();
    attachViewMapButtons();
    loadGoogleMaps();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
